<template>
    <div id="fluxStatistics">
        <div v-for="(item, index) in list" :key="'flux' + index" class="item">
            <h3>
                <span>流量使用情况(GB) - {{ item.ctccPoolName }}</span>
            </h3>
            <div :id="'flux' + index" :ref="'flux' + index" style="height:300px;width:412px"></div>
            <div class="info">
                <div>
                    <span>{{ item.amountData }}</span><br/>总流量
                </div>
                <div>
                    <span>{{ item.useData }}</span><br/>已用流量
                </div>
                <div>
                    <span>{{ item.remainData }}</span><br/>剩余流量
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getSupplierFlux } from '@/api/home.js'
var echarts = require('echarts');      // 引入 ECharts 主模块

export default {
    data(){
        return {
            list: []
        }
    },
    mounted(){
        var options = {
            tooltip: {
                trigger: 'item',
                formatter: "{a} <br/>{b}: {c} ({d}%)"
            },
            legend: {
                orient: 'vertical',
                x: 'left',
                data:['已用流量','剩余流量']
            },
            series: [
                {
                    name:'流量使用情况',
                    type:'pie',
                    radius: ['60%', '80%'],
                    center: ['50%', '55%'],
                    avoidLabelOverlap: false,
                    label: {
                        normal: {
                            show: false,
                            position: 'center'
                        },
                        emphasis: {
                            show: true,
                            textStyle: {
                                fontSize: '30',
                                fontWeight: 'bold'
                            }
                        }
                    },
                    labelLine: {
                        normal: {
                            show: false
                        }
                    },
                    color: ['#ff5643', '#25be3f'],
                    data:[
                        {value:0, name:'已用流量'},
                        {value:0, name:'剩余流量'}
                    ]
                }
            ]            
        }

        getSupplierFlux().then(res => {
            if(res.data.code == 200){
                var result = res.data.data;
                this.list = result;
                this.$nextTick( () => {
                    for(var i=0; i<result.length; i++){
                        
                        var myChart = echarts.init(document.getElementById('flux' + i));
                        options.series[0].data = [
                            {value: result[i].useData, name:'已用流量'},
                            {value: result[i].remainData, name:'剩余流量'}
                        ]
                        myChart.setOption(options);
                    }
                })
                

            }else{
                this.$message.error(res.data.message)
            }
        })
    }
}
</script>
<style lang="less" scoped>
#fluxStatistics {
    padding: 20px 0 0 20px;
    .item {
        float: left;
        width: 412px;
        margin: 0 30px 30px 0;
        border: 1px solid #e4e7ed;
        border-radius: 6px;
        h3 {
            display: flex;
            justify-content: space-between;
            font-size: 16px;
            padding: 10px;            
            border-bottom: 1px solid #e4e7ed;
            span {
                padding-left: 6px;
                border-left: 4px solid #409eff;
            }
        }
        .info {
            display: flex;
            justify-content: space-around;
            line-height: 2em;
            div {
                text-align: center;
                span {
                    color: #409eff;
                }
            }
        }
    }
}
</style>